import { render, staticRenderFns } from "./gpsCard.vue?vue&type=template&id=1870ab3b&"
import script from "./gpsCard.vue?vue&type=script&lang=js&"
export * from "./gpsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports